import type { AppConfig } from "./lib/types";

export const APP_CONFIG_DEFAULTS: AppConfig = {
  companyName: "Agiliztech",
  pageTitle: "Career Connector",
  pageDescription: "A web embed connected to an agent",

  supportsChatInput: true,
  supportsVideoInput: true,
  supportsScreenShare: true,
  isPreConnectBufferEnabled: true,

  logo: "/components/asserts/AppLogo.svg",
  accent: "#002cf2",
  logoDark: "/components/asserts/AppLogo.svg",
  accentDark: "#1fd5f9",
  startButtonText: "Start call",
};
